import React from "react";
import styles from "./TitleCard.module.css";

const TitleCard = ({ title, className }) => {
  return (
    <div className={`${className} text-center`}>
      <div className="d-flex justify-content-center">
        <div className={"top_line "}></div>
      </div>
      <span className={`${styles.title} `}>{title}</span>
    </div>
  );
};

export default TitleCard;
